var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('year-input',{ref:"editor",attrs:{"options":_vm.options,"propValue":_vm.propValue,"propInvisible":_vm.propInvisible,"dataId":_vm.dataId,"validateArg":_vm.validateArg},on:{"change":_vm.changeHandle,"click":_vm.clickHandle}})}
var staticRenderFns = []

export { render, staticRenderFns }